// Real 5-star Google reviews for Max Q - powered by QTechnics
// Source: Google Business profile (4.8 stars, 39 reviews)
export const GOOGLE_RATING = {
  aggregate: 4.8,
  total: 39,
  fiveStars: 37, // ~95% (4.8 of 5)
};

export const REVIEWS_URL = 'https://www.google.com/search?q=Max+Q+-+powered+by+QTechnics+%7C+Interieur+-+Technieken+-+Totaalprojecten&stick=H4sIAAAAAAAA_-NgU1I1qDAxTzY0NrQ0tkxNMjW2TEqzMqhINLQwN0gxtzRKtDQ0NzczWsTq7ptYoRCooKtQkF-eWpSaopBUqRAYkpqckZeZXKxQo-CZV5JalJlaWgRUAhFOzU7NA3HySxITcwqK8rNSk0tS8wAQPo8BcwAAAA';

export const GOOGLE_REVIEWS = [
  {
    name: 'Koen Marchal',
    initial: 'K',
    rating: 5,
    date: '2026-05-06',
    dateText: '1 week geleden',
    text: 'Zeer correcte afspraken die ook nagekomen worden. Zeer verzorgd en proper werk afgeleverd! Een aanrader!!',
  },
  {
    name: 'Lukas Vanderheyden',
    initial: 'L',
    rating: 5,
    date: '2026-04-15',
    dateText: '4 weken geleden',
    text: 'Zeer tevreden over de samenwerking. Professionele aanpak, duidelijke communicatie en kwalitatieve afwerking. Aanrader voor totaalprojecten!',
  },
  {
    name: 'Laura Vangenechten',
    initial: 'L',
    rating: 5,
    date: '2026-04-15',
    dateText: '4 weken geleden',
    text: 'Mooi resultaat en alles correct uitgevoerd. Aanrader!',
  },
  {
    name: 'Arne Vandenboer',
    initial: 'A',
    rating: 5,
    date: '2026-04-15',
    dateText: '4 weken geleden',
    text: 'Top ervaring, mooi werk afgeleverd.',
  },
  {
    name: 'Joke Van Hove',
    initial: 'J',
    rating: 5,
    date: '2026-04-15',
    dateText: '4 weken geleden',
    text: 'Top bedrijf om mee samen te werken!',
  },
  {
    name: 'Chayenne Julia',
    initial: 'C',
    rating: 5,
    date: '2026-04-15',
    dateText: '4 weken geleden',
    text: 'Topkwaliteit en vlotte service!',
  },
  {
    name: 'Bert Morren',
    initial: 'B',
    rating: 5,
    date: '2026-04-15',
    dateText: '4 weken geleden',
    text: 'Super tevreden! Bedankt.',
  },
  {
    name: 'Tom Maes',
    initial: 'T',
    badge: 'Local Guide',
    rating: 5,
    date: '2026-02-04',
    dateText: '14 weken geleden',
    text: 'Vakmanschap, gekoppeld aan betaalbare prijs en kwaliteit, daarbovenop de goede service en correcte afwerking. Werkmannen die meedenken en alles netjes opleveren.',
  },
  {
    name: 'Beate Luyckx',
    initial: 'B',
    rating: 5,
    date: '2025-03-12',
    dateText: '12 maart 2025',
    text: 'We lieten een bad vervangen door een inloopdouche. We zijn zeer tevreden over de werken. De communicatie liep vlot. De plaatsers waren bekwaam, vriendelijk en werkten heel netjes.',
  },
  {
    name: 'Alain Jongen',
    initial: 'A',
    rating: 5,
    date: '2025-03-05',
    dateText: '5 maart 2025',
    text: 'Professioneel gedaan, zeer snel en mooi afgewerkt binnen de tijd, zeer degelijk materiaal en het oude materiaal meegenomen. Zeer fijne mensen.',
  },
];
